import NiceModal from '@ebay/nice-modal-react';

import Button from 'components/field/Button';
import Tooltip from 'components/global/Tooltip';
import Typography from 'components/global/Typography';

import OrderCommentModal from 'pages/Shipments/ActionForms/OrderCommentModal';

const LastComment = ({ data }) => (
	<Tooltip title="clickToOpenAddComment" placement="top">
		<Button
			variant="blueBorderless"
			fullWidth
			onClick={() => {
				NiceModal.show(OrderCommentModal, { ID: data.ID, orderID: data.orderID });
			}}>
			<Typography color="var(--blue)" showCopyButton>
				{data?.lastComment ? data.lastComment : 'addComment'}
			</Typography>
		</Button>
	</Tooltip>
);

export default LastComment;
